<template>
	<div class="layers-container">
		<slot />
	</div>
</template>

<script>
// import { IndexedCollectionAdapter, SourceCollectionAdapter } from '../utils/collection'

export default {

  name: 'LayersContainer',
  methods: {
  	layerMounted(lyr) {
  		this._layers.push(lyr)
      this.$emit('layer-added', lyr)
      this.$emit('layers-changed', this.$layers)
  	},
  },
  data () {
    return {
      
    }
  },
  created () {
    this._layers = []

    Object.defineProperties(this, /** @lends module:map/view# */{
        $layers: {
          enumerable: true,
          get: () => this._layers
        },
        $map: {
          enumerable: true,
          get: () => this.$services.$map
        },
      })

    this.$parent.$emit('layers-container-created', this);
    this.$on('mounted', (e) => this.layerMounted(e));
  },
}
</script>

<style lang="css" scoped>
	
</style>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Base/LayersContainer.vue